export enum LDFeatureFlags {
  FRANCHISE_CATEGORIES_SALES_REPORT_NEW = 'franchise-categories-sales-report-new', // check if it's fully GA
  FRANCHISE_HOME_PAGE_TILES_NEW = 'franchise-home-page-tiles-new',
  FRANCHISE_HOME_PAGE_ITEMS_TABLE_NEW = 'franchise-home-page-items-table-new',
  FRANCHISE_HOME_PAGE_ITEMS_TABLE_OLD = 'franchise-home-page-items-table-old',
  FRANCHISE_HOME_PAGE_LOCATIONS_TABLE_NEW = 'franchise-home-page-locations-table-new',
  FRANCHISE_HOME_PAGE_PAST_THIRTY_DAYS_OLD = 'franchise-home-page-past-thirty-days-old',
  FRANCHISE_ITEMS_SALES_REPORT_NEW = 'franchise-items-sales-report-new',
  FRANCHISE_MODIFIER_SALES_REPORT_NEW = 'franchise-modifier-sales-report-new',
  FRANCHISE_ROYALTY_FEES = 'franchise-royalty-fees',
  FRANCHISE_ROYALTY_COLLECTIONS_COLUMN = 'franchise-royalty-collections-column',
  FRANCHISE_SALES_TRENDS = 'franchise-sales-trends',
  FRANCHISE_STORE_HOME_PAGE_PAST_THIRTY_DAYS_OLD = 'franchise-store-home-page-past-thirty-days-old',
  FRANCHISE_STORE_HOME_PAGE_TILES_NEW = 'franchise-store-home-page-tiles-new',
  FRANCHISE_STORE_HOME_PAGE_ITEMS_TABLE_NEW = 'franchise-store-home-page-items-table-new',
  FRANCHISE_STORE_HOME_PAGE_ITEMS_TABLE_OLD = 'franchise-store-home-page-items-table-old',
  FRANCHISE_LOYALTY_REPORT = 'franchise-loyalty-report',
  FRANCHISE_LOYALTY_SUPPORTS_PAID_MODIFIERS = 'franchise-loyalty-supports-paid-modifiers',
  FRANCHISE_LEGACY_SOURCE_REPORT = 'franchise-legacy-source-report',
  ENABLE_SFF_DISCOUNT_REDESIGN = 'enable-sff-discount-redesign',
  FRANCHISE_NEW_NAVIGATION = 'franchise-new-navigation',
  SFF_DISCOUNT_REPORT = 'sff-discount-report',
  SFF_GIFT_CARD_REPORT = 'sff-gift-card-report',
}
